import React from 'react';

// Red de seguridad global: captura excepciones de render en cualquier página
// y muestra un fallback elegante en vez de tumbar toda la app (pantalla en
// blanco en producción / overlay rojo en desarrollo).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Punto único para enviar a un servicio de logs en el futuro.
    console.error('ErrorBoundary capturó una excepción:', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        className="min-h-screen flex items-center justify-center bg-slate-50 p-6"
        data-testid="error-boundary-fallback"
      >
        <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
              fill="none" stroke="#DC3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
              <path d="M12 9v4" /><path d="M12 17h.01" />
            </svg>
          </div>
          <h1 className="font-heading text-xl font-bold text-slate-900 mb-2">Algo salió mal</h1>
          <p className="text-slate-500 text-sm mb-6">
            Ocurrió un error inesperado o el servidor no está disponible en este momento.
            Puedes reintentar o recargar la página.
          </p>
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={this.handleRetry}
              data-testid="error-boundary-retry"
              className="px-4 py-2 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition-colors"
            >
              Reintentar
            </button>
            <button
              onClick={this.handleReload}
              data-testid="error-boundary-reload"
              className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 text-sm font-medium hover:bg-slate-50 transition-colors"
            >
              Recargar página
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
